export { LineSkeleton, RectSkeleton, TextSkeleton } from '@sberdevices/plasma-core';
export type { LineSkeletonProps, RectSkeletonProps, TextSkeletonProps } from '@sberdevices/plasma-core';
